<template>
  <el-dialog
      :width="this.screenWidth<=575.98?'85%':'30%'"
      append-to-body
      :title="$t('login.changepassword')"
      :visible.sync="dialogFormVisiblePwd"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="closeDialogPwd">
    <el-form :model="formPwd" :rules="rulesPwd" ref="rulePwd" @keyup.enter.native="submitPwd">
      <el-form-item prop="email">
        <el-input :label="$t('home.emailaddress')" clearable autocomplete="off" v-model="formPwd.email" disabled/>
      </el-form-item>
      <el-form-item prop="code">
        <el-input :placeholder="$t('login.verificationcode')" v-model="formPwd.code" style="color: #43d98e">
          <template slot="append">
            <el-button @click="sendCodePwd" id="sendcodePwd" style="" type="primary" :disabled="!show">
              <!-- <span v-show="show">Send Code</span> -->
              <span v-show="show">{{ $t("login.sendcode") }}</span>
              <span v-show="!show" class="count">{{ count }} s</span>
            </el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <passwordInput v-model="formPwd.password" :placeholder="$t('login.password')"/>
      </el-form-item>
      <el-form-item prop="agapassword">
        <passwordInput v-model="formPwd.agapassword" :placeholder="$t('login.agapassword')"/>
      </el-form-item>
    </el-form>
    <div>
      <el-button type="primary" @click="submitPwd">{{ $t("login.modify") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
const TIME_COUNT = 60;
import {
  isPassword,
  isEmail
} from "@/util/validate";
import {
  getResetPwdCode,
  updatePwd
} from "@/request/requests";
import passwordInput from "@/components/passwordInput";

import {
  MessageError,
  MessageSuccess,
  startLoading
} from "@/util/util"
export default {
  name: "forgetPass",
  props:{
    email: String
  },
  components:{
    passwordInput
  },
  data(){
    let validatePswLen = (rule, value, callback) => {
      if (!isPassword(value)) {
        // callback(new Error('The password meets uppercase and lowercase letters, numbers and special characters, any combination of three of them, and the length is between 8 and 16!'));
        // callback(new Error('비밀번호는 대문자와 소문자, 숫자, 특수문자 중 3가지 조합을 모두 충족하며, 길이는 8자에서 16자 사이!'));
        callback(new Error(this.$t("login.validatepswlen")));
      } else {
        callback();
      }
    };
    let validatePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t("login.passwordagain")));
      } else if (value !== this.formPwd.password) {
        callback(new Error(this.$t("login.validatepswlen")));
      } else {
        callback();
      }
    };
    return{
      screenWidth:null,
      dialogFormVisiblePwd: false,
      formPwd: this.initFormPwd(),
      show: true,
      count: '', // 初始化次数
      timer: null,
      rulesPwd: {
        email: [{
          required: true,
          message: this.$t('home.pleaseenter') + ' ' + this.$t('home.emailaddress'),
          trigger: 'blur'
        },
          // { validator: validateEmail, trigger: 'blur' }
        ],
        code: [{
          required: true,
          message: this.$t('home.pleaseenter') + ' ' + this.$t('login.verificationcode'),
          trigger: 'blur'
        }, ],
        password: [{
          required: true,
          message: this.$t('home.pleaseenter') + ' ' + this.$t('login.password'),
          trigger: 'blur'
        },
          {
            validator: validatePswLen,
            trigger: 'blur'
          },
        ],
        agapassword: [{
          required: true,
          message: this.$t('login.passwordagain'),
          trigger: 'blur'
        },
          {
            validator: validatePwd,
            trigger: 'blur'
          }
        ],
      },
    }
  },
  watch: {
    email:{
      handler(newVal) {
        this.formPwd.email = newVal;
      },
      immediate: true
    }
  },
  methods:{
    init(){
      this.dialogFormVisiblePwd = true;
    },
    submitPwd(){
      this.$refs.rulePwd.validate((valid) => {
        if (valid) {
          this.toupdatepwd()
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    async toupdatepwd() {
      let loading = startLoading()
      let res = await updatePwd(this.formPwd)
      if (res.status == "200") {
        loading.close()
        MessageSuccess("Successfully modified!")
        this.closeDialogPwd()
      } else {
        loading.close()
        MessageError(res.msg)
      }
      loading.close()
    },
    sendCodePwd() {
      if (!isEmail(this.formPwd.email)) {
        MessageError(this.$t("home.emailerror"));
        return false;
      } else {
        if (!this.timer) {
          this.toSendCodePwd()
        }
      }
    },
    async toSendCodePwd() {
      let loding = startLoading()
      let res = await getResetPwdCode(this.formPwd.email)
      if (res.status == "200") {
        loding.close()
        MessageSuccess(this.$t("home.verificationsend"))
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      } else {
        loding.close()
        MessageError(res.msg)
      }
    },
    closeDialogPwd() {
      this.dialogFormVisiblePwd = false
      this.formReg = this.initFormPwd()
      this.$emit('closeForget')
    },
    initFormPwd() {
      return {
        email: "",
        code: "",
        password: "",
        agapassword: "",
      }
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>

</style>